require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-what-is-financial-literacy.json") })
        }
      }, "path---es-articles-what-is-financial-literacy");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-what-is-financial-literacy!./.cache/json/es-articles-what-is-financial-literacy.json
// module id = 2479
// module chunks = 231608221292675